<template>
  <main role="main" class="page-content">
    <div class="page-content-overlay" @click="hideNavigation" />

    <breadcrumb />

    <router-view />
  </main>
</template>

<script>
import Breadcrumb from './Breadcrumb.vue';

export default {
  components: { Breadcrumb },

  methods: {
    hideNavigation() {
      this.$store.dispatch('setMobileNav', false);
    }
  }
};
</script>
